import React from 'react';

import './FilterAttributes.scss';

import { Panel } from '../Panel';
import { RefinementList } from 'react-instantsearch-hooks-web';
import { useNumericMenu } from 'react-instantsearch-hooks-web';
import { useRefinementList } from 'react-instantsearch-hooks-web';
import Util from '../../../../../../../src/js/Util';

function FilteredValues(props) {
    const attribute = props.attribute;
    let filtered_values = [];

    props.checkedFilters.forEach( f => {
        if ( f.filter_name === attribute ) {
            f[`filter_options_${attribute}`].forEach( o => {
                filtered_values.push(o);
            } );
        }
    } );

    return filtered_values;
};

function NumericMenu(props) {
    const { items, refine } = useNumericMenu(props);
    const filtered_values = FilteredValues(props);

    return (
        <div className="ais-RefinementList">
            <ul className="ais-RefinementList-list">
                {
                    items.map( ( item, i ) => {
                        const defaultRefined = filtered_values.includes(item.label);
                        const isRefined = defaultRefined ? true : ( item.isRefined ?? false );
                        return (
                            <li className="ais-RefinementList-item" key={i}>
                                <label className="ais-RefinementList-label">
                                    <input checked={isRefined} className="ais-RefinementList-checkbox" name="price" onChange={() => refine(item.value)} type="radio" value={item.value} disabled={defaultRefined} />
                                    <span className="ais-RefinementList-labelText">{item.label}</span>
                                </label>
                            </li>
                        );
                    } )
                }
            </ul>
        </div>
    );
}

export class FilterAttributes extends React.Component<any, any> {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        //console.log( 'props', this.props );
        const keys = Object.keys( this.props.defaultRefinements );

        let disableInt = setInterval( () => {
            keys.forEach( ( key, i ) => {
                const array = this.props.defaultRefinements[key] || [];

                if ( array !== typeof Array)
                    return;

                const attr = document.querySelector(`.algolia-filter[data-attr="${key}"]`);

                // loop through array of values
                array.forEach( v => {
                    const input = attr.querySelector(`input[value="${v}"]:checked`);

                    if ( input ) {
                        if (input.disabled) {
                            clearInterval(disableInt);
                        } else {
                            input.disabled = true;
                        }
                    }
                } );
            } );
        }, 100 );
    }

    renderSwitch( f, props ) {
        const sortBy = Array.isArray( f.sortBy ) ? f.sortBy : ['name:asc'];

        switch ( f.refinement ) {
            case 'NumericMenu':
                return <NumericMenu attribute={f.attribute} items={f.items} {...props} limit={100} />
            case 'NumericList':
                return <RefinementList attribute={f.attribute} sortBy={sortBy} limit={100} />
            default:
                return <RefinementList attribute={f.attribute} limit={100} sortBy={['name:asc']}/>
        }
    }

    render() {
        return (
            <div className={`algolia-filter-attributes${!this.props.activeFilter ? ' hide' : ''}`}>
                <div className="container">
                    { this.props.filters.map( ( f, i ) => {
                        return (
                            <div className={`algolia-filter algolia-filter--${f.attribute}${f.attribute === this.props.activeFilter ? ' active' : ''}`} data-attr={f.attribute} key={i}>
                                <Panel toggleFilter={this.props.toggleFilter} header={f.title}>
                                    {this.renderSwitch(f, this.props)}
                                </Panel>
                            </div>
                        );
                    } ) }

                    <div className="algolia-filter-attributes-toggle">
                        <button className="algolia-filter-attributes-toggle-button" onClick={() => { this.props.hideFilter() }}>
                            {Util.translate('Hide Filter')}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}
